import React from 'react';
import {tid} from '../../../../../testUtils';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {SCENARIO_ACTION_MENU_IDS} from '../../../../../test/types';
import {useScenarioDeleteSideBarModal} from './useScenarioDeleteSideBarModal';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import {canDeleteInstance} from '../../../../../permissions/usePermissions';
import {TrashCan16} from '@carbon/icons-react';

const ScenarioDeleteActionMenuButton: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const {ModalComponent, openModal} = useScenarioDeleteSideBarModal(props);

  return (
    <>
      <SideBarButtonItem
        red
        {...tid(SCENARIO_ACTION_MENU_IDS.DELETE)}
        permission={canDeleteInstance(props.model, props.subModel, props.scenario)}
        onClick={openModal}
        icon={<TrashCan16 />}
        text="Delete"
      />
      {ModalComponent}
    </>
  );
};

export default ScenarioDeleteActionMenuButton;
